<template>
  <FormInput :labelSize="labelSize" :type="type" v-bind="$attrs">
    <div v-if="icon" :slot="iconPosition">
      <Icon :name="icon" :size="20" :type="iconType" />
    </div>
  </FormInput>
</template>

<script>
import FormInput from '@/lego/components/inputs/FormInput.vue';
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: { FormInput, Icon },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    icon: {
      type: String,
      required: false,
    },
    iconPosition: {
      type: String,
      default: 'prefix',
    },
    labelSize: {
      type: String,
      default: 'lg',
    },
    iconType: {
      type: String,
      default: 'solid',
    },
  },
};
</script>
